import { client, handleRequestBody } from "./client.ts";

export interface Account {
	id: string;
	name: string;
	city: string;
	state: string;
	logo_url?: string;
	disabled_at: string | null;
	created_at: string;
	updated_at: string;
}

interface AccountResponse {
	account: Account;
}

export async function uploadAccountLogo(
	accountId: string,
	file: File,
): Promise<Account> {
	const form = new FormData();
	form.append("file", file);
	const { account } = await handleRequestBody(() =>
		client.put<AccountResponse>(`/accounts/${accountId}/logo`, form),
	);
	return account;
}

export async function deleteAccountLogo(accountId: string): Promise<Account> {
	const { account } = await handleRequestBody(() =>
		client.delete<AccountResponse>(`/accounts/${accountId}/logo`),
	);
	return account;
}
